/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-QLS-Cart-Note': 'true'
        }
      };

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 700);

      this.addEventListener('focusin', () => {
        document.documentElement.classList.add('qls-cart-note-editing');
      });

      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;

        window.setTimeout(() => {
          if (!this.matches(':focus-within')) {
            document.documentElement.classList.remove('qls-cart-note-editing');
          }
        }, 120);
      });

      // Save quietly after the customer pauses typing.
      this.addEventListener('input', this.debouncedHandleNoteChange);

      const popup = this.closest('.cart-drawer-popup');
      if (popup) {
        popup.querySelectorAll('.js-close').forEach((control) => {
          control.addEventListener('click', () => {
            const field = this.querySelector('textarea, input');
            if (field) field.blur();
            document.documentElement.classList.remove('qls-cart-note-editing');
          });
        });
      }

      this.querySelectorAll('[data-qls-cart-note-save]').forEach((button) => {
        button.addEventListener('click', this.handleSaveClick.bind(this));
      });
    }

    handleSaveClick(evt) {
      const field = this.querySelector('textarea, input[name="note"]');
      if (!field) return;

      evt.preventDefault();

      // Save immediately rather than waiting for the background debounce.
      this.handleNoteChange({ target: field });
      field.blur();
      document.documentElement.classList.remove('qls-cart-note-editing');

      const disclosureHost = this.closest('details-disclosure');
      if (disclosureHost && typeof disclosureHost.close === 'function') {
        disclosureHost.close();
      } else if (this.disclosure) {
        this.disclosure.open = false;
      }
    }

    handleNoteChange(evt) {
      if (this.cartNoteToggle) {
        const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts).catch(() => {
        // Keep the field usable even if a background save fails.
      });
    }
  }

  customElements.define('cart-note', CartNote);
}
